import React, { Component } from 'react'
import { SecureContainer, FormInput } from '../../components'
import { Link } from 'react-router-dom'
import { validate } from '../../api'
import { replace } from '../../actions/nav-actions'
import { connect } from 'react-redux'
import { notify } from '../../utils'

class CreateAccount extends Component {
    state = {
        code: '',
        error: ''
    }
    validateAndNext(event) {
        event.preventDefault();
        this.setState({ error: '' }, () => {
            validate(this.state.code)
                .then((organization) => this.props.replace(`/create-account/${organization.code}`))
                .catch(e => notify('Validation Error', e.message, 'error'));
        });
    }
    render() {
        return (
            <SecureContainer title="New User">
                <form onSubmit={this.validateAndNext.bind(this)}>
                    <FormInput
                        value={this.state.code}
                        onChange={(code) => this.setState({ code: code.toUpperCase() })}
                        placeholder="Organization Code"
                        required />
                    <div className="form-group row">
                        <div className="col-12">
                            <button
                                type="submit"
                                className="btn btn-info waves-effect waves-light btn-block">LOGIN</button>
                        </div>
                    </div>
                    <div className="form-group row" style={{ margin: '32px 0' }}>
                        <span className="col-12 text-center">Or</span>
                    </div>
                    <div className="form-group row">
                        <div className="col-12">
                            <Link to="/create-organization" className="btn btn-outline-info btn-block">CREATE AN ORGANIZATION</Link>
                        </div>
                    </div>
                </form>
            </SecureContainer>
        )
    }
}

const mapDispatchToProps = dispatch => ({
    replace(routeName) {
        dispatch(replace(routeName))
    }
})

export default connect(null, mapDispatchToProps)(CreateAccount);


// WEBPACK FOOTER //
// ./src/routers/CreateAccount/index.js